if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      // Agregado: bandera para saber si ya se ha interactuado con la selección
      this.hasUserChanged = false;
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects"),
      ).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest(".thb-product-detail");
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(
          `#MediaGallery-${this.dataset.section}`,
        );
        this.hideVariants = this.productSlider.dataset.hideVariants === "true";
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      // Al cargar la ficha, se actualizan los metafields de la variante por defecto
      this.updateMetafields();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });

      // Se ejecuta el bloque de actualización de información sólo cuando ya hubo interacción del usuario
      if (this.hasUserChanged) {
        var final_variant_value = "";
        var variant_names = document.getElementsByClassName("m_titlee");
        const elements_hide = document.querySelectorAll(".custom_div");
        const textElement = document.querySelector(
          ".dp-energy-efficiency-badge-rating-border",
        );
        var variant_meta_values = document.getElementsByClassName("meta_value");
        for (var i = 0; i < variant_names.length; i++) {
          if (
            variant_names[i].innerHTML.trim() ==
            this.currentVariant.title.trim()
          ) {
            final_variant_value = variant_meta_values[i].innerHTML;
          }
        }
        textElement.textContent = final_variant_value;
        console.log(final_variant_value);
        elements_hide.forEach((element) => {
          if (final_variant_value) {
            element.classList.remove("hidden");
          } else {
            element.classList.add("hidden");
          }
        });
      } else {
        // Se marca que ya hubo una interacción para futuras actualizaciones
        this.hasUserChanged = true;
      }
    }

    updateMetafields() {
      const currentMetafield = variantMetafields.find(
        (metafield) => metafield.id == this.currentVariant.id,
      );

      const heightContainer = document.querySelector(".variant_height");
      const heightSpan = document.querySelector(".height-text");
      const widthContainer = document.querySelector(".variant_width");
      const widthSpan = document.querySelector(".width-text");
      const lengthContainer = document.querySelector(".variant_length");
      const lengthSpan = document.querySelector(".length-text");

      if (currentMetafield.height) {
        heightContainer.style.display = "flex";
        heightSpan.innerText = currentMetafield.height;
      } else {
        heightContainer.style.display = "none";
      }

      if (currentMetafield.width) {
        widthContainer.style.display = "flex";
        widthSpan.innerText = currentMetafield.width;
      } else {
        widthContainer.style.display = "none";
      }

      if (currentMetafield.length) {
        lengthContainer.style.display = "flex";
        lengthSpan.innerText = currentMetafield.length;
      } else {
        lengthContainer.style.display = "none";
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
          this.option_keys.push(fieldset.querySelector("select").name);
        } else if (fieldset.querySelectorAll("input").length) {
          this.option_keys.push(fieldset.querySelector("input").name);
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
      this.dataset.options = this.options;
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value="${option}"]`,
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(
        `[data-media-id="${mediaId}"]`,
      );

      this.productSlider
        .querySelectorAll("[data-media-id]")
        .forEach((element) => {
          element.classList.remove("is-active");
        });

      this.setImageSetMedia();

      activeMedia.classList.add("is-active");

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`,
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) {
          console.error("❌ Error: No se encontró el input[name='id']");
          return;
        }
        input.value = this.currentVariant ? this.currentVariant.id : "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper",
      );
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;
      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");
            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut,
          );
        });
    }

    toggleAddButton(disable = false, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );
      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );
        if (!submitButtonText) return;
        submitButton.removeAttribute("disabled");
        submitButton.classList.remove("loading");
        submitButtonText.textContent = window.theme.variantStrings.addToCart;
      });
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`,
      );
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();
      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          },
        );

        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options,
        );

        this.fieldsets.forEach((fieldset, i) => {
          var isOne = false;
          const fieldset_options = Object.values(available_options)[i];
          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              let fieldset3 = Object.values(available_options)[2];
              if (fieldset3.length === 1) {
                isOne = true;
              }
              if (
                i === 1 &&
                fieldset3.some((option) => !option.isUnavailable) &&
                isOne === true
              ) {
                fieldset.querySelectorAll("input").forEach((input, input_i) => {
                  input.classList.toggle(
                    "is-disabled",
                    fieldset_options[input_i].isUnavailable,
                  );
                });
              } else if (i === 1) {
                return;
              } else {
                fieldset.querySelectorAll("input").forEach((input, input_i) => {
                  input.classList.toggle(
                    "is-disabled",
                    fieldset_options[input_i].isUnavailable,
                  );
                });
              }
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]',
        ).dataset.index;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex],
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(
        `[data-set-name="${this.imageSetName}"]`,
      );
      if (this.hideVariants) {
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      } else {
        let set_images = Array.from(selected_set_images).filter(
          function (element) {
            return element.dataset.group === group;
          },
        );
        set_images.forEach((thumb) => {
          thumb.parentElement.prepend(thumb);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce(
        (options, variant) => {
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;
            let entry = options[index].find(
              (option) => option.value === variant[index],
            );
            if (typeof entry === "undefined") {
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0,
            );
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index,
              )
            ) {
              entry.isUnavailable = true;
            }
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });
          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        },
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      });
    }
  }
  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector(
        ".product-images-buttons",
      );
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });
      observer.observe(this, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        characterData: false,
      });
      this.setupProductGallery();
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener("scroll", this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver((entries) =>
          this.onPaginationResize(),
        );
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector(".product-single__media-zoom");
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute("title"),
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(
          this.querySelectorAll(".product-images__slide--image"),
        ).filter((element) => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll(".pswp")[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true,
        };
      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest(".product-images__slide");
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest(".product-single__media"),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        };
        if (typeof PhotoSwipe !== "undefined") {
          let pswp = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options,
          );
          pswp.listen("firstUpdate", () => {
            pswp.listen("parseVerticalMargin", function (item) {
              item.vGap = {
                top: 50,
                bottom: 50,
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll(".product-single__media-zoom").forEach(
        function (link) {
          let thumbnail = link.closest(".product-single__media");
          let clone = link.cloneNode(true);
          thumbnail.append(clone);
          link.remove();
          clone.addEventListener("click", (e) =>
            openPswp(e, clone, options, pswpElement, items),
          );
        },
      );
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0,
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
      this.currentPageElement = this.pagination.querySelector(
        ".slider-counter--current",
      );
      this.pageTotalElement = this.pagination.querySelector(
        ".slider-counter--total",
      );
      this.prevButton = this.pagination.querySelector(
        'button[name="previous"]',
      );
      this.nextButton = this.pagination.querySelector('button[name="next"]');
      this.prevButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this),
      );
      this.nextButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this),
      );
      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0,
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.scrollLeft + 1 * this.sliderItemOffset
          : this.scrollLeft - 1 * this.sliderItemOffset;
      this.scrollTo({ left: this.slideScrollPosition });
    }
    updatePagination() {
      if (!this.nextButton) return;
      const previousPage = this.currentPage;
      this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        );
      }
      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }
      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
      ) {
        this.nextButton.setAttribute("disabled", "disabled");
      } else {
        this.nextButton.removeAttribute("disabled");
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.scrollLeft
      );
    }
  }
  customElements.define("product-slider", ProductSlider);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form.reportValidity()) {
          return;
        }
        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button",
        );
        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });
        this.handleErrorMessage();
        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        let formData = new FormData(this.form);
        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }
            this.renderContents(response);
            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });
        let product_drawer = document.getElementById("Product-Drawer");
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer
            .querySelector(".product-quick-images--container")
            .classList.remove("active");
          document.body.classList.remove("open-quick-view");
          if (window.innerWidth < 1069) {
            product_drawer.classList.remove("active");
            if (document.getElementById("Cart-Drawer")) {
              document.getElementById("Cart-Drawer").classList.add("active");
              document.body.classList.add("open-cart");
              document
                .getElementById("Cart-Drawer")
                .querySelector(".product-recommendations--full")
                .classList.add("active");
              dispatchCustomEvent("cart-drawer:open");
            }
          } else {
            product_drawer
              .querySelector(".product-quick-images--container")
              .addEventListener("transitionend", function () {
                product_drawer.classList.remove("active");
                if (document.getElementById("Cart-Drawer")) {
                  document
                    .getElementById("Cart-Drawer")
                    .classList.add("active");
                  document.body.classList.add("open-cart");
                  document
                    .getElementById("Cart-Drawer")
                    .querySelector(".product-recommendations--full")
                    .classList.add("active");
                  dispatchCustomEvent("cart-drawer:open");
                }
              });
          }
          if (!document.getElementById("Cart-Drawer")) {
            document.body.classList.remove("open-cc");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          document.body.classList.add("open-cc");
          document.body.classList.add("open-cart");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.setupVariantLabelSync();
    }
    setupVariantLabelSync() {
      const sectionId = this.dataset.section;
      const label = this.querySelector("[data-sticky-variant-label]");
      if (!label || !sectionId) return;
      document.addEventListener("product:variant-change", (event) => {
        if (
          !event.detail ||
          String(event.detail.sectionId) !== String(sectionId)
        )
          return;
        const variant = event.detail.variant;
        if (variant && variant.title) {
          label.textContent = variant.title;
          label.hidden = false;
        } else {
          label.textContent = "";
          label.hidden = true;
        }
      });
    }

    /** La galería principal sigue ocupando la franja inferior (donde va el sticky): no mostrar barra. */
    updateGalleryOverlap() {
      const gallery = document.getElementById(
        `MediaGallery-${this.dataset.section}`,
      );
      this.galleryOverlapsStickyZone = false;
      if (!gallery) return;
      const rect = gallery.getBoundingClientRect();
      const bottomReservePx = 100;
      this.galleryOverlapsStickyZone =
        rect.bottom > window.innerHeight - bottomReservePx;
    }

    showStickyIfEligible() {
      this.updateGalleryOverlap();
      if (this.galleryOverlapsStickyZone) {
        this.classList.remove("sticky--visible");
        return;
      }
      if (this.isFooterVisible || !this.formPassed) {
        this.classList.remove("sticky--visible");
        return;
      }
      this.classList.add("sticky--visible");
    }

    setupObservers() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById("footer");
      const ngfContainer = document.querySelector(".ngf__container");

      this.formPassed = false;
      this.isFooterVisible = false;
      this.galleryOverlapsStickyZone = false;

      if (!form) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === footer || entry.target === ngfContainer) {
              if (entry.isIntersecting || entry.intersectionRatio > 0) {
                this.classList.remove("sticky--visible");
              } else if (
                !entry.isIntersecting &&
                this.formPassed &&
                !this.isFooterVisible
              ) {
                this.showStickyIfEligible();
              }
            }
            if (entry.target === form) {
              const boundingRect = form.getBoundingClientRect();
              if (
                entry.intersectionRatio === 0 &&
                window.scrollY > boundingRect.top + boundingRect.height
              ) {
                this.formPassed = true;
                this.showStickyIfEligible();
              } else if (entry.intersectionRatio === 1) {
                this.formPassed = false;
                this.classList.remove("sticky--visible");
              }
            }
          });
        },
        {
          threshold: [0, 0.1, 0.5, 1],
        },
      );

      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isFooterVisible = true;
              this.classList.remove("sticky--visible");
            } else {
              const footerRect = footer ? footer.getBoundingClientRect() : null;
              const ngfRect = ngfContainer
                ? ngfContainer.getBoundingClientRect()
                : null;
              const footerOutOfView =
                !footerRect || footerRect.top > window.innerHeight;
              const ngfOutOfView = !ngfRect || ngfRect.top > window.innerHeight;

              if (footerOutOfView && ngfOutOfView && this.formPassed) {
                this.isFooterVisible = false;
                this.showStickyIfEligible();
              }
            }
          });
        },
        {
          threshold: 0,
          rootMargin: "0px 0px 0px 0px",
        },
      );

      let scrollRaf = 0;
      const onScrollOrResize = () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => {
          scrollRaf = 0;
          this.showStickyIfEligible();
        });
      };
      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize, { passive: true });

      observer.observe(form);
      if (footer) {
        observer.observe(footer);
        footerObserver.observe(footer);
      }
      if (ngfContainer) {
        observer.observe(ngfContainer);
        footerObserver.observe(ngfContainer);
      }

      this.showStickyIfEligible();
    }
  }
  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }
  customElements.define("side-panel-links", ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

// Envolver en IIFE para evitar conflictos de scope y solo ejecutar en páginas de producto
(function () {
  "use strict";

  // Solo ejecutar si estamos en una página de producto o hay variant-selects
  const isProductPage =
    document.querySelector("variant-selects") ||
    document.querySelector("variant-radios") ||
    window.location.pathname.includes("/products/");

  if (!isProductPage) {
    return; // Salir silenciosamente si no es página de producto
  }

  // Verificar que variantSelects existe antes de usarlo
  const variantSelects = document.querySelector("variant-selects")
    ? document.querySelector("variant-selects")
    : document.querySelector("variant-radios");
  let pickerType,
    fieldsets,
    productJson,
    selectedOptions = [];

  if (!variantSelects) {
    // Solo mostrar warning en páginas de producto reales
    if (window.location.pathname.includes("/products/")) {
      // Silenciar el warning - es normal que no exista en algunas páginas
    }
    return;
  }

  pickerType =
    variantSelects.querySelectorAll("fieldset").length > 0
      ? "radios"
      : "selects";
  fieldsets =
    pickerType == "radios"
      ? Array.from(variantSelects.querySelectorAll("fieldset"))
      : Array.from(
          variantSelects.querySelectorAll(".product-form__input--dropdown"),
        );
  const productJsonElement = variantSelects.querySelector(
    '[type="application/json"]',
  );
  if (!productJsonElement) {
    // Silenciar el warning
    return;
  }

  try {
    productJson = JSON.parse(productJsonElement.textContent);
    variantSelects.addEventListener("change", rebuildOptions);
    rebuildOptions();
  } catch (e) {
    // Silenciar errores de parsing
    return;
  }

  function validCombo(inputValue, optionLevel) {
    if (!productJson || !selectedOptions || !selectedOptions.length) {
      return false;
    }
    for (let i = 0; i < productJson.length; i++) {
      if (optionLevel == 1) {
        if (
          productJson[i].option1 == selectedOptions[0] &&
          productJson[i].option2 == inputValue
        ) {
          return true;
        }
      } else {
        if (
          productJson[i].option1 == selectedOptions[0] &&
          productJson[i].option2 == selectedOptions[1] &&
          productJson[i].option3 == inputValue
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function rebuildOptions() {
    if (!variantSelects || !fieldsets || !productJson) {
      return;
    }
    selectedOptions = fieldsets.map((fieldset) => {
      return pickerType == "radios"
        ? Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ).value
        : Array.from(
            fieldset.querySelectorAll("select"),
            (select) => select.value,
          );
    });
    for (
      let optionLevel = 1, n = fieldsets.length;
      optionLevel < n;
      optionLevel++
    ) {
      const inputs =
        pickerType == "radios"
          ? fieldsets[optionLevel].querySelectorAll("input")
          : fieldsets[optionLevel].querySelectorAll("option");
      inputs.forEach((input) => {
        input.disabled = validCombo(input.value, optionLevel) ? false : true;
        if (pickerType == "radios") {
          const label = fieldsets[optionLevel].querySelector(
            `label[for="${input.id}"]`,
          );
          label.style.display = input.disabled ? "none" : "";
        } else {
          input.hidden = validCombo(input.value, optionLevel) ? false : true;
        }
      });
    }
    for (
      let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      if (pickerType == "radios") {
        if (
          fieldsets[optionLevel].querySelector("input:checked").disabled ===
          true
        ) {
          change = fieldsets[optionLevel].querySelector(
            "input:not(:disabled)",
          ).checked = true;
        }
      } else {
        if (
          fieldsets[optionLevel].querySelector("option:checked").disabled ===
          true
        ) {
          change = fieldsets[optionLevel].querySelector(
            "option:not(:disabled)",
          ).selected = "selected";
        }
      }
      if (change)
        variantSelects.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
})(); // Cerrar IIFE

$(document).on("click", "quick-view", function () {
  const sidePanel = $(".side-panel-inner");
  sidePanel.css("position", "relative").append(`
        <div class="loader-overlay">
            <div class="loader"></div>
        </div>
    `);
  sidePanel.css("opacity", "0.5");
  setTimeout(() => {
    sidePanel.css("opacity", "1");
    sidePanel.find(".loader-overlay").remove();
    handleVariantSelection();
  }, 2000);
});
